let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6PXox")).then(() => parcelRequire('jYd12'));